/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as ActionTypes from "constants/ActionTypes";
import { enhanceProject, saveProject } from "actions/ProjectActions";
import FilterTypes from "constants/FilterTypes";

export function setFilter({ filterName, enabled, strengthPercent }) {
  return async (dispatch) => {
    const result = await dispatch({
      type: ActionTypes.SET_FILTER,
      filterName,
      enabled,
      strengthPercent,
    });

    if (enabled && filterName === FilterTypes.ENHANCE_SPEECH) {
      dispatch(enhanceProject());
    }

    dispatch(saveProject()); // Skip await so save does not block UI
    return result;
  };
}
